import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import arrowLeft from './arrow-left.svg'

const Wrapper = styled(Link).attrs({
  className:
    'bb b--black-10 no-underline bg-white tl mw7 center ph3 ph4-ns pv2 flex items-center justify-between'
})``

const StyledH3 = styled.h3.attrs({
  className: 'f4 f3-ns mb0 mt3'
})`
  color: ${props => props.theme.primaryColor}
`

const StyledP = styled.p.attrs({
  className: 'mt2'
})`
  color: ${props => props.theme.greyLight}
`

const ListItem = ({ title, description, url, target, ...rest }) =>
  <Wrapper to={url} target={target} {...rest}>
    <div>
      <StyledH3>
        {title}
      </StyledH3>
      <StyledP>
        {description}
      </StyledP>
    </div>
    <img src={arrowLeft} alt="" />
  </Wrapper>

ListItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.string
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/ListItem/ListItem.js